export default class ServerException extends Error {
    statusCode: number;

    constructor(message: string, statusCode: number) {
        super(message);
        this.name = 'Server Exception';
        this.statusCode = statusCode;
    }
}